<script setup lang="ts">
import { LpProductsMenu } from '@thehotelsnetwork/lampo';
import { useFeatureFlags } from '@thehotelsnetwork/vue-feature-flags';

import useUserState from '@/state/useUserState';
import { track } from '@/utils/analytics';

const env = import.meta.env || {};

const baseUrl = env.VUE_APP_NAKAMA_URL;

const { flags: featureFlags } = useFeatureFlags();

const { userData } = useUserState();

const productClickTracking = (product: string) => {
  track('navigation-to-products', { otherData: { product } });
};
function isProductItemVisible(productId: string): boolean {
  if (productId === 'demand') {
    return featureFlags.value.demand;
  }
  if (productId === 'ernest') {
    return featureFlags.value.ernest && userData.ernest;
  }
  return true;
}
</script>

<template>
  <LpProductsMenu
    current-product-id="benchdirect"
    :base-url="baseUrl"
    :is-visible="isProductItemVisible"
    @product-click="productClickTracking"
  />
</template>
